import { AvailableBreak } from '../types/breaks';

export const mockAvailableBreaks: AvailableBreak[] = [
	{
		id: '0199de9f-d01e-74e4-be9f-b1ac7b3c9ba7',
		name: 'Rest Break',
		paid: true,
		duration: 15,
		recordedDuration: null,
		availabilityType: 'anytime',
		available: true,
		availableIn: null,
		availableAfterMinutesWorked: null,
		unavailableIn: null,
		availableAt: null,
		unavailableAt: null,
	},
	{
		id: '0199de9f-d01e-74e4-be9f-b1ac7b3c9ba8',
		name: 'Lunch Break',
		paid: true,
		duration: 60,
		recordedDuration: null,
		availabilityType: 'hours_worked',
		available: false,
		availableIn: 180, // 3 hours
		availableAfterMinutesWorked: 240, // 4 hours
		unavailableIn: null,
		availableAt: null,
		unavailableAt: null,
	},
	{
		id: '0199de9f-d01e-74e4-be9f-b1ac7b3c9ba9',
		name: 'Nap Time',
		paid: true,
		duration: 60,
		recordedDuration: null,
		availabilityType: 'time_of_day',
		available: false,
		availableIn: 1, // 3 hours
		availableAfterMinutesWorked: null,
		unavailableIn: null,
		availableAt: '12:00',
		unavailableAt: '13:00',
	},
];

// export const mockAvailableBreaks: AvailableBreak[] = [];
